import { GeneralAction } from '../../../../../shared/infrastructure/store/actions/general_action';
import { SubscriptionType } from '../actions/action.creator';
import { subscriptionState } from '../state/state';
import { ISubscriptionState } from '../state/state.interface';

const Subscription = (state: ISubscriptionState = subscriptionState, action: GeneralAction<SubscriptionType>) => {
    switch (action.type) {
        case SubscriptionType.GET_SUBSCRIPTIONS:
            return { ...state, error: false, errorMessage: null, loading: true };
        case SubscriptionType.GET_SUBSCRIPTIONS_FAILURE:
            return { ...state, error: true, errorMessage: action.payload, loading: false };
        case SubscriptionType.GET_SUBSCRIPTIONS_SUCCESS:
            return { ...state, allSubscriptions: action.payload, loading: false, error: false, errorMessage: null };
        case SubscriptionType.GET_SINGLE_SUBSCRIPTION:
            return { ...state, loading: true, errorr: false, errorMessage: false };
        case SubscriptionType.GET_SINGLE_SUBSCRIPTION_SUCCESS:
            return { ...state, singleSubscription: action.payload, loading: false };
        case SubscriptionType.GET_SINGLE_SUBSCRIPTION_FAILURE:
            return { ...state, error: true, errorMessage: action.payload, loading: false };
        case SubscriptionType.CANCEL_SUBSCRIPTION:
            return {
                ...state,
                cancellingSubscription: true,
                isSubCancellingFailed: false,
                isSubCancellingSuccess: false
            };
        case SubscriptionType.CANCEL_SUBSCRIPTION_FAILURE:
            return {
                ...state,
                cancellingSubscription: false,
                errorCancelling: action.payload,
                isSubCancellingFailed: true
            };
        case SubscriptionType.CANCEL_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                cancelledSubscription: action.payload,
                cancellingSubscription: false,
                isSubCancellingSuccess: true
            };
        case SubscriptionType.CLEAR_CANCEL_SUBSCRIPTION_STATE:
            return {
                ...state,
                cancelledSubscription: null,
                cancellingSubscription: false,
                errorCancelling: null,
                isSubCancellingFailed: false,
                isSubCancellingSuccess: false
            };
        default:
            return state;
    }
};

export default Subscription;
